import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationFetchStatus = createSelector(
  [(store: RootState) => store.locationShow.locationFetchStatus],
  (data) => data
);
